<template>
    <el-dialog
    :title="(operation=='add'?'发布':'编辑')+'实训任务'"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @close="handleClose"
    width="120rem">
    <div class="dia-box">
        <div class="item">
            <p>任务名称</p>
            <el-input v-model="form.name" placeholder="请输入任务名称"></el-input>
        </div>
        <div class="item-box">
            <div class="element-box">
                <p>任务开始时间</p>
                <el-date-picker
                v-model="form.startTime"
                type="datetime"
                placeholder="选择任务开始时间">
                </el-date-picker>
            </div>
            <div class="element-box" style="margin-left: 10rem;">
                <p>任务结束时间</p>
                <el-date-picker
                v-model="form.endTime"
                type="datetime"
                placeholder="选择任务结束时间">
                </el-date-picker>
            </div>
        </div>
        <div class="item" style="margin-top: 3rem;">
            <p>关联班级</p>
            <el-select v-model="form.classes" multiple placeholder="请选择关联班级">
                <el-option
                v-for="item in classList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="relate-box">
            <p>关联软件</p>
            <div class="table-content-box">
                <div class="top-box">
                    <div class="category-box">
                        <div v-for="(item,index) in Category" @click="changeCategory(item)" :class="{'category-active':item.value==currentCategory}" :key="index">{{ item.label }}</div>
                    </div>
                    <div class="input-box">
                        <p>搜索</p>
                        <el-input v-model="keywords" style="width: 20rem;" @keydown.enter.native="search" clearable @clear="search" placeholder="请输入名称">
                            <template slot="prefix">
                                <div class="search-ipt-box">
                                    <img style="cursor: pointer;width: 16px;height: auto;" src="../../../assets/image/magSys/search.png" @click="search" alt="">
                                </div>
                            </template>
                        </el-input>
                    </div>
                </div>
                <div class="content-box" v-infinite-scroll="loadSoftware">
                    <div v-for="(item,index) in softworeList" :class="{'active-border':isChecked(item.id)}" class="soft-item" @click="addSoftware(item)" :key="index">
                        <div class="label-type" :class="filterVersion(item.resType).value">{{ filterVersion(item.resType).label }}</div>
                        <img :src="item.softwareCover?$severUrl(item.softwareCover):virtual" alt="">
                        <el-tooltip effect="dark" :disabled="item.softwareName.length<=12" :content="item.softwareName" placement="top-start">
                            <div :class="{'active-color':isChecked(item.id)}" class="overflow">{{ item.softwareName }}</div>
                        </el-tooltip>
                    </div>
                    <no-data v-if="softworeList.length==0"></no-data>
                </div>
            </div>
        </div>
    </div>
    <div slot="footer" class="dialog-footer">
        <div class="cancel-btn" @click="handleClose">取消</div>
        <div class="save-btn" v-debounce="saveTask">保存</div>
    </div>
    </el-dialog>
</template>
<script>
import { Category,getDateTime } from '@/utils/utils';
import { VirtualSoftwarePageList } from '@/api/examine';
import { GetClassList } from '@/api/class';
import { filterVersion } from '@/utils/utils';
import { SaveTask,UpdateTask } from '@/api/trainTask';
import NoData from '../../common/NoData.vue';
    export default {
  components: { NoData },
        data(){
            return {
                Category:[{label:'全部',value:''},...Category],
                dialogVisible:false,
                /**仿真软件默认图片 */
                virtual:require('../../../assets/image/resource/virtual.png'),
                form:{
                    name:'',
                    startTime:'',
                    endTime:'',
                    classes:[],
                    softwareIds:[]
                },
                operation:'',
                /**班级列表 */
                classList:[],
                taskId:'',
                /**软件搜索关键字 */
                keywords:'',
                /**当前所属分类 */
                currentCategory:'',
                softworeList:[],
                pages:{
                    current:1,
                    size:15,
                    total:0
                }
            }
        },
        methods:{
            filterVersion,
            /**搜索软件 */
            search(){
                this.pages.current=1;
                this.virtualSoftwarePageList();
            },
            changeCategory(item){
                this.currentCategory=item.value;
                this.search();
            },
            /**下拉加载仿真软件 */
            loadSoftware(){
                let total=this.pages.current*this.pages.size;
                if(total>=this.pages.total)return;
                this.pages.current++;
                this.virtualSoftwarePageList();
            },
            /**软件选择校验 */
            verification(item){
                let arr=this.form.softwareIds;
                if(arr.length==0)return true;
                let obj={};
                arr.forEach(item=>{
                    obj[item.resType]?obj[item.resType].push(item.id):(obj[item.resType]=[item.id]);
                })
                if(item.resType=='单机'&&obj[item.resType]&&obj[item.resType].length>=0){
                    this.$msg({
                            showClose: true,
                            message: "单机版的软件最多只能选择一个",
                            type: "warning",
                        });
                    return false;
                }
                for(let key in obj){
                    if(key!=item.resType){
                        if(obj[key]&&obj[key].length>0){
                            this.$msg({
                                showClose: true,
                                message: "只能选择一种类型的软件",
                                type: "warning",
                            });
                            return false;
                        }
                    }
                }
                return true;
            },
            /**添加仿真软件 */
            addSoftware(item){
                if(this.isChecked(item.id)){
                    let index=this.form.softwareIds.findIndex(e=>e.id==item.id);
                    index!=-1&&this.form.softwareIds.splice(index,1);
                }else{
                    if(!this.verification(item))return;
                    this.form.softwareIds.push(item);
                }
            },
            /**初始化表单 */
            handleClose(){
                this.form={
                    name:'',
                    startTime:'',
                    endTime:'',
                    classes:[],
                    softwareIds:[]
                };
                this.currentCategory='';
                this.dialogVisible=false;
            },
            /**判断软件是否已选中 */
            isChecked(id){
                let el=this.form.softwareIds.find(item=>{
                    return id==item.id;
                });
                if(el){
                  return true;
                }else{
                  return false;
                }
            },
            /**分页查询班级信息 */
            getClassList(){
                let params={
                "classCode": "",
                "className": "",
                }
                GetClassList(params).then(res=>{
                    if(res.code==200){
                        this.classList=res.data.map(item=>{
                            return {
                                label:item.className,
                                value:item.id
                            }
                        });
                    }
                })
            },
            /**新增实训任务 */
            saveTask(){
                let ids=this.form.softwareIds.map(item=>item.id);
                var params={
                "beginTime": getDateTime(new Date(this.form.startTime).getTime()),
                "classIds": this.form.classes,
                "endTime": getDateTime(new Date(this.form.endTime).getTime()),
                "softwareIds": ids,
                "taskName": this.form.name
                }
                if(this.operation=='add'){
                    SaveTask(params).then(res=>{
                    if(res.code==200){
                        this.dialogVisible=false;
                        this.$emit('save_task');
                        this.$msg({
                        showClose: true,
                        message: "新增实训任务成功",
                        type: "success",
                    });
                    }
                })
                }else{
                    params.id=this.taskId;
                    UpdateTask(params).then(res=>{
                        if(res.code==200){
                            this.dialogVisible=false;
                            this.$emit('save_task');
                            this.$msg({
                            showClose: true,
                            message: "修改实训任务成功",
                            type: "success",
                        });
                        }
                    })
                }
            },
            /**分页查询虚拟仿真软件 */
            virtualSoftwarePageList(){
                let params={
                "classifyCode": this.currentCategory,
                "current": this.pages.current,
                "ids": [],
                "resourceName": this.keywords,
                "size": this.pages.size
                }
                VirtualSoftwarePageList(params).then(res=>{
                    if(res.code==200){
                        if(this.pages.current==1){
                            this.softworeList=res.data.records;
                        }else{
                            this.softworeList=[...this.softworeList,...res.data.records];
                        }
                        this.pages.total=res.data.total;
                    }
                })
            },
        },
        mounted(){
            this.virtualSoftwarePageList();
        }
    }
</script>

<style lang="less" scoped>
/deep/.el-dialog__title{
    font-size: 16px;
    font-weight: 700;
    color: #334681;
}
/deep/.el-dialog{
    border-radius: 1rem;
}
/deep/.el-dialog__body{
    padding: 1rem 2rem 3rem 2rem;
}
.item{
    &> :nth-child(2){
        margin-top: 16px;
    }
}
.cancel-btn{
    width: 8.8rem;
    height: 4rem;
    background: rgba(56,125,255,0.00);
    border: 1px solid #e8ecef;
    border-radius: 0.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.save-btn{
    width: 8.8rem;
    height: 4rem;
    background: var(--blue);
    border: 1px solid #e8ecef;
    border-radius: 0.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    margin-left: 3.5rem;
    cursor: pointer;
}
.dialog-footer{
    display: flex;
    justify-content: center;
}
.item-box{
    display: flex;
    margin-top: 3rem;
}
.element-box{
    &> :nth-child(2){
        margin-top: 16px;
    }
}
.dia-box{
    color: #334681;
}
.relate-box{
    margin-top: 3rem;
}
.table-content-box{
    height: 42rem;
    border: 1px solid #e8ecef;
    margin-top: 16px;
}
.top-box{
    border-bottom: 1px solid #e8ecef;
    font-size: 16px;
    color: #334681;
    padding: 0 2.4rem 0;
    justify-content: space-between;
    align-items: center;
    display: flex;
    .category-box{
        display: flex;
        &> :nth-child(n){
        margin-left: 4.8rem;
        cursor: pointer;
        height: 100%;
        padding: 2.5rem 0;
        border-bottom: 0.4rem solid transparent;
        transition: all 0.3s;
        }
        &> :nth-child(1){
            margin-left: 0;
        }
    }
    .input-box{
        display: flex;
        align-items: center;
        &> :nth-child(1){
            margin-right: 1rem;
            cursor: pointer;
        }
    }
}
.input-box{
/deep/.el-input__inner{
    height: 4rem;
    border-radius: 1rem;
    padding-left: 3.5rem;
}
.search-ipt-box{
    display: flex;
    align-items: center;
    width: 3.5rem;
    justify-content: center;
    height: 100%;
}
}
.category-active{
    border-bottom: 0.4rem solid var(--blue) !important;
}
.content-box{
    height: calc(100% - 8rem);
    overflow: auto;
    padding: 2rem;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    &> :nth-child(n){
        margin-left: 1.5rem;
        cursor: pointer;
    }
    &> :nth-child(5n+1){
        margin-left: 0;
    }
    &> :nth-child(n+6){
            margin-top: 1.5rem;
        }
}
.soft-item{
    width: calc((100% - 6rem)/5);
    border: 1px solid #e0e8f2;
    position: relative;
    .label-type{
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 0px 0px 1rem 0px;
        padding: 0.3rem 0.4rem;
        color: #ffffff;
    }
    img{
        width: 100%;
        // height: 13.5rem;
        aspect-ratio: var(--aspectRatio);
        object-fit: cover;
    }
    &> :nth-child(3){
        padding: 1rem 1.7rem;
        font-size: 14px;
        color: #151C34;
        font-weight: 700;
    }
}
.active-border{
    border: 2px solid var(--blue) !important;
}
.active-color{
    color: var(--blue) !important;
}
/deep/.el-input__inner{
    min-height: 3rem !important;
}
</style>